import { render, staticRenderFns } from "./FAQnew.vue?vue&type=template&id=acf8e2f8&scoped=true&"
import script from "./FAQnew.vue?vue&type=script&lang=js&"
export * from "./FAQnew.vue?vue&type=script&lang=js&"
import style0 from "./FAQnew.vue?vue&type=style&index=0&id=acf8e2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf8e2f8",
  null
  
)

export default component.exports